"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const CommentEmailHistoryModal = (props) => {
    const { handleOpenModal, isOpen, userEmails } = props;
    return (react_1.default.createElement(pulse_components_1.PulseModalBase, { classes: {
            root: [styles_modules_less_1.default['email-history-modal__root']],
            dialog: {
                paper: styles_modules_less_1.default['email-history__container'],
            },
        }, open: isOpen, onModalClose: handleOpenModal, PulseModalHeaderProps: {
            classes: {
                root: styles_modules_less_1.default['email-history__header--root'],
                titlePrimary: styles_modules_less_1.default['email-history__header--title'],
            },
            primaryText: 'Email history',
        }, footer: false },
        react_1.default.createElement("div", { className: styles_modules_less_1.default['email-history__content--container'] },
            react_1.default.createElement("p", { className: styles_modules_less_1.default['email-history__content--status'] }, "This comment was sent to the following users:"),
            react_1.default.createElement("div", { className: styles_modules_less_1.default['email-history__content--emails'] }, userEmails.length > 0 ? (userEmails.map((item, index) => {
                var _a, _b, _c;
                return (react_1.default.createElement("div", { key: index, className: styles_modules_less_1.default['user-email--container'] },
                    react_1.default.createElement("div", { className: styles_modules_less_1.default['user-email--name'] }, (_a = item.user) === null || _a === void 0 ? void 0 : _a.name),
                    react_1.default.createElement("div", { className: styles_modules_less_1.default['user-email--email'] },
                        react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default['user-email--icon'], 'fal fa-envelope') }), (_b = item.user) === null || _b === void 0 ? void 0 :
                        _b.email),
                    react_1.default.createElement("div", { className: styles_modules_less_1.default['user-email--time'] },
                        react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default['user-email--icon'], 'fal fa-calendar') }), (_c = item.note) === null || _c === void 0 ? void 0 :
                        _c.time)));
            })) : (react_1.default.createElement("label", { className: styles_modules_less_1.default['user-history__no-email--status'] }, "No email history"))))));
};
exports.default = CommentEmailHistoryModal;
